import React from 'react';
interface RollingNumberProps {
  value: number;
  className?: string;
  /** ms for one digit roll */
  duration?: number;
}
/**
 * Scoreboard / odometer style number. Each digit lives in an overflow-hidden
 * slot with a vertical 0-9 column that slides to the active digit, so when the
 * value changes the digits roll up/down instead of swapping abruptly.
 */
export function RollingNumber({
  value,
  className = '',
  duration = 600
}: RollingNumberProps) {
  const digits = String(Math.max(0, Math.floor(value))).split('');
  return <span className={`inline-flex items-center tabular-nums leading-none ${className}`} aria-label={String(value)} data-id="element-162" data-mp="3m2l0ql68ke2r">
      {digits.map((d, i) => <Digit key={i} digit={Number(d)} duration={duration} data-id="element-163" data-mp="3c3vtdmbyuc0r" data-mpi={i} />)}
    </span>;
}
function Digit({
  digit,
  duration
}: {
  digit: number;
  duration: number;
}) {
  return <span aria-hidden="true" className="relative inline-block overflow-hidden" style={{
    height: '1em',
    width: '0.62em'
  }} data-id="element-164" data-mp="25p3ab8j2cz5d">
      <span className="absolute left-0 top-0 flex flex-col" style={{
      transform: `translateY(-${digit * 10}%)`,
      transition: `transform ${duration}ms cubic-bezier(0.16, 1, 0.3, 1)`
    }} data-id="element-165" data-mp="23kpa55hz27eg">
        {Array.from({
        length: 10
      }, (_, n) => <span key={n} className="flex items-center justify-center" style={{
        height: '1em'
      }} data-id="element-166" data-mp="1tlq3ttkoinum">
              {n}
            </span>)}
      </span>
    </span>;
}